module.exports = __webpack_public_path__ + "static/img/dmn-logo.abd29862.svg";